import { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

const setupCompanyStyles = (showLongList: boolean) =>
    makeStyles((theme: Theme) =>
        createStyles({
            refineDomainWrapper: {
                width: "100%",
                position: "relative",
                padding: showLongList ? theme.spacing(4) : theme.spacing(4, 7, 0),
            },
            peerLabel: {
                fontSize: 20,
                fontWeight: 600,
                letterSpacing: 0.15,
                marginBottom: theme.spacing(1),
            },
            peerSelect: {
                width: "100%",
            },
            projectionHeaderHiddenPanel: {
                backgroundColor: theme.palette.background.blue,
                paddingBottom: theme.spacing(2),
                position: "absolute",
                zIndex: -1,
                top: "100%",
                left: 0,
                width: "100%",
                boxShadow: "0 2px 10px #646464",
            },
            projectionHeader: {
                backgroundColor: theme.palette.background.blue,
                color: theme.palette.common.black,
                position: "relative",
                zIndex: 2,
            },
        })
    )();

export default setupCompanyStyles;
